// @flow
import DishesTable from './DishesTable';
import DishesTableTHead from './DishesTableTHead';
import DishesTableRowItem from './DishesTableRow';

export default DishesTable;
export { DishesTableTHead, DishesTableRowItem };
